/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import * as yup from 'yup';

import { NO_ONLY_SPACES_REGEX } from '../../util/validation/constants';
import { ApplicationStepMessages } from './application-tab/messages';
import { PageStepMessages } from './page-tab/messages';

export const settingsSchema = yup.object().shape({
  private: yup
    .object()
    .shape({
      secrets: yup
        .object()
        .shape({
          application_secret: yup
            .string()
            .required(ApplicationStepMessages.required)
            .matches(NO_ONLY_SPACES_REGEX, {
              message: ApplicationStepMessages.nonEmptyAppSecret,
              excludeEmptyString: true
            }),
          page_access_token: yup
            .string()
            .required(PageStepMessages.required)
            .matches(NO_ONLY_SPACES_REGEX, {
              message: PageStepMessages.nonEmptyPageAccessToken,
              excludeEmptyString: true
            }),
          verification_token: yup
            .string()
            .required()
            .matches(NO_ONLY_SPACES_REGEX, {
              message: PageStepMessages.nonEmptyPageAccessToken,
              excludeEmptyString: true
            })
        })
        .nullable()
        .default(undefined)
    })
    .nullable()
    .default(undefined),
  webhook_url: yup.string().required()
});

export const FIELDS = {
  APPLICATION_SECRET: 'private.secrets.application_secret',
  PAGE_ACCESS_TOKEN: 'private.secrets.page_access_token',
  VERIFICATION_TOKEN: 'private.secrets.verification_token',
  WEBHOOK_URL: 'webhook_url'
};
